import { apiClient } from './api'

export interface ChecklistItem {
  id: string
  jobId: string
  label: string
  checked: boolean
  revision: number
  checkedAt: string | null
  checkedBy: string | null
}
export interface ChecklistChange { checked: boolean; revision: number }
export interface ChecklistTransport {
  list(jobId: string): Promise<ChecklistItem[]>
  add(jobId: string, id: string, label: string): Promise<ChecklistItem>
  set(jobId: string, id: string, change: ChecklistChange): Promise<ChecklistItem>
}
const path = (jobId: string) => `/api/jobs/${encodeURIComponent(jobId)}/checklist`
export const checklistApi: ChecklistTransport = {
  async list(jobId) {
    const res = await apiClient.get<{ data: { items: ChecklistItem[] } }>(path(jobId))
    return res.data.data.items
  },
  async add(jobId, id, label) {
    const res = await apiClient.put<{ data: ChecklistItem }>(`${path(jobId)}/${id}`, { label })
    return res.data.data
  },
  async set(jobId, id, change) {
    const res = await apiClient.patch<{ data: ChecklistItem }>(`${path(jobId)}/${id}`, change)
    return res.data.data
  },
}
